if (!customElements.get('branded-store-help')) {
  customElements.define('branded-store-help', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.launcher = this.querySelector('.bs-help-launcher');
      this.dialog = this.querySelector('dialog');
      this.status = this.querySelector('.bs-help-status');
      this.chatHint = this.querySelector('.bs-help-chat-ready');
      if (!this.launcher || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.launcher.hidden = false;
      if (this.classList.contains('bs-help--public')) document.body.classList.add('mh-help-ready');
      this.launcher.addEventListener('click', () => this.open());
      this.externalTriggers = document.querySelectorAll('[data-bs-help-open]');
      this.onExternalOpen = event => {
        event.preventDefault();
        this.returnFocusTarget = event.currentTarget;
        this.open();
      };
      this.externalTriggers.forEach(trigger => trigger.addEventListener('click', this.onExternalOpen));
      this.querySelector('[data-help-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        this.launcher.setAttribute('aria-expanded', 'false');
        this.externalTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        const focusTarget = this.returnFocusTarget || this.launcher;
        this.returnFocusTarget = null;
        focusTarget.focus({ preventScroll: true });
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.querySelector('[data-help-chat]').addEventListener('click', () => this.showChat());
      this.querySelector('[data-help-customize]')?.addEventListener('click', () => {
        const trigger = document.querySelector('.custom-customize__button');
        if (!trigger) return;
        this.returnFocusTarget = trigger;
        this.dialog.close();
        trigger.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
      this.querySelector('[data-help-size]')?.addEventListener('click', () => {
        const trigger = document.querySelector('.product__button-size-guide');
        if (trigger && document.querySelector('.sizeguide .custom-size-table')) {
          this.dialog.close();
          trigger.click();
        }
      });
    }
    open() {
      document.body.classList.remove('bs-help-chat-visible');
      this.chatHint.hidden = true;
      this.status.hidden = true;
      const sizeButton = this.querySelector('[data-help-size]');
      if (sizeButton) sizeButton.hidden = !document.querySelector('.sizeguide .custom-size-table');
      const customizeButton = this.querySelector('[data-help-customize]');
      if (customizeButton) customizeButton.hidden = !document.querySelector('.custom-customize__button');
      this.dialog.showModal();
      this.launcher.setAttribute('aria-expanded', 'true');
      this.externalTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
    }
    showChat() {
      const chat = document.querySelector('shopify-chat');
      if (!chat) {
        this.status.textContent = this.dataset.chatUnavailable;
        this.status.hidden = false;
        return;
      }
      document.body.classList.add('bs-help-chat-visible');
      this.chatHint.hidden = false;
      this.dialog.close();
    }
    disconnectedCallback() {
      this.externalTriggers?.forEach(trigger => trigger.removeEventListener('click', this.onExternalOpen));
      document.body.classList.remove('bs-help-chat-visible');
      if (this.classList.contains('bs-help--public')) document.body.classList.remove('mh-help-ready');
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
